(function () {
    'use strict';
    /*
     * Copyright (c) 2019-20 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .controller('EpisodeTypeGlanceCtrl', EpisodeTypeGlanceCtrl);

    EpisodeTypeGlanceCtrl.$inject = ['_'];

    function EpisodeTypeGlanceCtrl(_) {
        var vm = this;

        var notStarted = 'Not Started';
        var complete = 'Complete';

        vm.getAttributeTextType = getAttributeTextType;
        vm.getAttribute = getAttribute;
        vm.setAttribute = setAttribute;

        vm.getAgeFromDateAttribute = getAgeFromDateAttribute;
        vm.getSetDateAttribute = getSetDateAttribute;
        vm.dateGetterSetterFunctions = {};

        vm.getFutureDateMeasure = getFutureDateMeasure;
        vm.getMeasureRec = getMeasureRec;
        vm.getMeasure = getMeasure;
        vm.setMeasure = setMeasure;

        vm.formatNextExerciseDay = formatNextExerciseDay;

        var type = vm.episodeObject.type;
        var workflow = type ? type.workflow : null;
        var measures = type ? type.measures : null;

        if (workflow && measures) {
            vm.trackedMeasureRec = getMeasureRec(workflow.trackedMeasureId);
            vm.nextChangeMeasureRec = getMeasureRec(workflow.nextChangeMeasureId);
            vm.completedMeasureRec = getMeasureRec(workflow.completedMeasureId);
        }

        if (vm.episodeObject.workflowTrigger) {
            var linkedScrip = vm.episodeObject.workflowTrigger;
            if (linkedScrip && linkedScrip.frequencyPerDay) {
                linkedScrip._frequencyDays = 1.0 / linkedScrip.frequencyPerDay;
                linkedScrip._frequencyDaysTemp = linkedScrip._frequencyDays;
            }
            if (linkedScrip && _.isFinite(linkedScrip.nextExerciseDay)) {
                linkedScrip._nextExerciseDay = linkedScrip.nextExerciseDay;
                linkedScrip._nextExerciseDayTemp = linkedScrip.nextExerciseDay;
            }
        }

        // Force int attributes to numeric to we can edit them with input type="number"
        _.each(vm.episodeObject.customValues, function (value, id, values) {
            var attrs = workflow.attributes;
            var attr = attrs ? _.find(attrs, function (value) {
                return value && value.id === id;
            }) : null;
            if (attr && attr.type === 'int') {
                values[id] = parseInt(value, 10);
            }
        });

        vm.episodeObject.measureValues = vm.episodeObject.measureValues || {};

        /**
         * Returns the text type to use to edit an attribute according to its attribute type.
         *
         * @param {Object} attr the attribute
         * @returns {String} the text type to use to edit the attribute
         */
        function getAttributeTextType(attr) {
            if (attr && attr.type === 'int') {
                return 'number';
            }
            else {
                return 'text';
            }
        }

        /**
         * Gets the value of an attribute from the current (edit or not edit) episode object.
         *
         * @param {Object} attr the attribute to get the value for
         * @returns {String|Number} the attribute value or a not available string
         */
        function getAttribute(attr) {
            var values = vm.editFlag
                ? vm.episodeObjectEdit.customValues
                : vm.episodeObject.customValues;

            return values && values[attr.id] ? values[attr.id] : 'N/A';
        }

        /**
         * Sets an attribute value into the edit episode object.
         *
         * @param {String|Number} value the value to set
         * @param {Object} attr the attribute to set
         */
        function setAttribute(value, attr) {
            if (!vm.episodeObjectEdit.customValues) {
                vm.episodeObjectEdit.customValues = {};
            }

            vm.episodeObjectEdit.customValues[attr.id] = value;
        }

        /**
         * Returns an array of numbers from 0 to the passed scale value, for generating measure setting choices.
         * @param {Number} scale the scale of the measure
         * @returns {Number[]} the choices
         */
        function getChoices(scale) {
            var choices = [notStarted];
            for (var i = 1; i < scale; i++) {
                choices.push(i);
            }
            choices.push(complete);

            return choices;
        }

        /**
         * Returns a function that gets or sets a calendary date attribute.
         *
         * The calendar date is represented as a string in the format YYYY-MM-DD. But this function returns an ISO 8601 date string
         * of midnight UTC, which is the format used by the date picker.
         */
        function getSetDateAttribute(attr) {
            if (!attr) {
                return undefined;
            }

            if (!vm.episodeObject.customValues) {
                vm.episodeObject.customValues = {};
            }

            if (!vm.dateGetterSetterFunctions[attr.id]) {
                vm.dateGetterSetterFunctions[attr.id] = function (value) {
                    if (vm.editFlag) {
                        // Edit mode: Setter or Getter for the edit object
                        if (value !== undefined) {
                            var calendarDate = value
                                ? new Date(value).toLocaleDateString('en-CA') // 'en-CA' outputs in YYYY-MM-DD format
                                : null;
                            vm.episodeObjectEdit.customValues[attr.id] = calendarDate;
                        }

                        var storedDate = vm.episodeObjectEdit.customValues[attr.id];
                        if (storedDate) {
                            var yearMonthDay = storedDate.split('-');
                            var year = yearMonthDay[0];
                            var month = yearMonthDay[1];
                            var day = yearMonthDay[2];
                            var localDate = new Date(year, month - 1, day); // Treat as local date
                            return localDate.toISOString();
                        }
                        return null;
                    }
                    else {
                        var storedDate = vm.episodeObject.customValues[attr.id];
                        if (storedDate) {
                            var yearMonthDay = storedDate.split('-');
                            var year = yearMonthDay[0];
                            var month = yearMonthDay[1];
                            var day = yearMonthDay[2];
                            var localDate = new Date(year, month - 1, day); // Treat as local date
                            return localDate.toISOString();
                        }
                        return null;
                    }
                };
            }

            return vm.dateGetterSetterFunctions[attr.id];
        }

        /**
         * Gets the date (formatted as yyyy-MM-dd) from the attribute value, and returns the number of full years since that date.
         */
        function getAgeFromDateAttribute(attr) {
            if (!attr) {
                return null;
            }

            // Retrieve the stored calendar date (yyyy-MM-dd)
            var storedDate = vm.episodeObject.customValues[attr.id];
            if (!storedDate) {
                return null; // No date set
            }

            // Parse the stored date into year, month, and day
            var yearMonthDay = storedDate.split('-').map(Number);
            var year = yearMonthDay[0];
            var month = yearMonthDay[1];
            var day = yearMonthDay[2];

            // Create a Date object for the birth date
            var birthDate = new Date(year, month - 1, day); // Month is zero-based

            // Ensure the date is valid
            if (isNaN(birthDate.getTime())) {
                return null; // Invalid date
            }

            // Get the current date
            var today = new Date();

            // Calculate the age in years
            var age = today.getFullYear() - birthDate.getFullYear();

            // Adjust the age if the current date is before the birth date in the current year
            var isBeforeBirthday =
                today.getMonth() < birthDate.getMonth() ||
                (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate());

            if (isBeforeBirthday) {
                age--;
            }

            return age;
        }

        /**
         * Gets a tracked measure record by ID.
         * @param {String} measureId the ID of the record to add
         */
        function getMeasureRec(measureId) {
            var measure = _.find(measures, byId(measureId));
            if (measure && measureId) {
                return {
                    id: measure.id,
                    description: measure.description,
                    scale: measure.scale,
                    precision: measure.precision,
                    choices: getChoices(measure.scale)
                };
            }

            return null;
        }

        /**
         * Gets the currently set measure value from the measure record.
         * @param {Object} rec the measure record
         * @returns {Number} the measure value
         */
        function getMeasure(rec) {
            var dp = vm.editFlag
                ? vm.episodeObjectEdit.measureValues[rec.id] || getMeasureDataPoint(rec.id)
                : getMeasureDataPoint(rec.id);

            if (!dp || !_.isFinite(dp.value)) {
                return null;
            }

            if (workflow && rec.id === workflow.trackedMeasureId) {
                if (dp.value <= 0.0) {
                    return notStarted;
                }
                else if (dp.value >= 1.0) {
                    return complete;
                }
            }

            var scaledValue = dp.value * rec.scale;
            var precision = rec.precision ? rec.precision : 0;

            return _.round(scaledValue, precision);
        }

        /**
         * Converts a future date measure (days from now) into a date string.
         * @param {Object} rec the measure record
         * @returns {String} the date string from the future date measure
         */
        function getFutureDateMeasure(rec) {
            var days = getMeasure(rec);
            if (_.isFinite(days) && days >= 0) {
                var millis = days * 24 * 60 * 60 * 1000;
                var date = new Date(Date.now() + millis);
                var formatter = new Intl.DateTimeFormat('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                });

                return formatter.format(date);
            }
        }

        /**
         * Sets a measure value into the episode edit object.
         * @param {Number} value the value to set
         * @param {Object} rec the measure object
         */
        function setMeasure(value, rec) {
            var existingDp = getMeasureDataPoint(rec.id);

            if (workflow && rec.id === workflow.trackedMeasureId) {
                if (value === notStarted) {
                    value = 0;
                }
                else if (value === complete) {
                    value = rec.scale;
                }
            }

            if (existingDp && existingDp.value !== value) {
                vm.episodeObjectEdit.measureValues[rec.id] = {
                    calendarDate: existingDp.calendarDate,
                    scale: rec.scale,
                    value: value / rec.scale
                };
            }
            else {
                delete vm.episodeObjectEdit.measureValues[rec.id];
            }
        }

        /**
         * Digs the current date point object for the measure indicated by id from the episode object's measure details.
         *
         * Also stashes the current measure date, under the assumption that is the one that should be set
         * if the therapist sets a value.
         *
         * @param {string} id the ID of the measure
         * @returns {number|null} the value of the measure or null
         */
        function getMeasureDataPoint(id) {
            var details = vm.episodeObject.measureDetails;
            var detail = _.find(details, function (item) {
                return _.get(item, 'measure.id') === id;
            });

            return _.last(detail.dataPoints);
        }

        /**
         * Returns a predicate that returns true if an item has the passed ID.
         * @param {String} id the ID to match
         * @returns {Function} a function that matches on the ID
         */
        function byId(id) {
            return function (item) {
                return item.id === id;
            };
        }

        /**
         * Formats the value for display as the next exercise day.
         *
         * @param {Number} value the value to format
         * @returns {String} the formatted value
         */
        function formatNextExerciseDay(value) {
            if (value < 0) {
                return "" + (-value) + " days overdue";
            }

            if (value === 0) {
                return "Today";
            }

            return value;
        }
    }
})();